import React from 'react'
import { motion } from 'framer-motion'
import { MdArrowOutward } from 'react-icons/md'
import { RevealLine } from './ui/Reveal'

const MEDIUM_PROFILE = 'https://medium.com/@tommywilson972'

const articles = [
  {
    title: 'Stop Migrating to Next.js: How I Rendered Social Media Metadata with Express',
    blurb:
      'Serving dynamic Open Graph and social-preview metadata straight from an Express server — no framework migration required.',
    tag: 'Backend · SSR',
    url: 'https://medium.com/@tommywilson972/stop-migrating-to-next-js-how-i-rendered-social-media-metadata-with-express-7b6a07d14b6e',
  },
  {
    title: 'Understanding the Context API in React',
    blurb:
      'A practical guide to sharing state across your component tree and escaping prop-drilling for good.',
    tag: 'React',
    url: 'https://medium.com/@tommywilson972/understanding-the-context-api-in-react-b068689eaba7',
  },
  {
    title: 'Angular vs React: A Tale of Frontend Giants',
    blurb:
      'Two frontend giants compared — their philosophies, ergonomics, and when to reach for each.',
    tag: 'Frontend',
    url: 'https://medium.com/@tommywilson972/angular-vs-react-a-tale-of-frontend-giants-62526eca6e5b',
  },
]

export const ArticlesSection = () => {
  return (
    <section id='writing' className=' px-6 md:px-10 py-24 md:py-32 border-b border-ink/10'>
      <div className=' max-w-7xl mx-auto'>
        {/* header */}
        <div className=' grid md:grid-cols-12 gap-8 mb-12 md:mb-16'>
          <div className=' md:col-span-4'>
            <p className=' font-mono text-sm text-mint-deep'>(03)</p>
            <h2 className=' font-display text-4xl md:text-5xl text-maroon mt-2 tracking-tight'>
              <RevealLine>Writing</RevealLine>
            </h2>
          </div>
          <p className=' md:col-span-6 md:col-start-7 self-end text-base md:text-lg text-ink/60 leading-relaxed'>
            Essays and deep-dives on building for the web — backend rendering, React internals,
            and the trade-offs between frameworks.
          </p>
        </div>

        {/* article cards */}
        <div className=' grid md:grid-cols-3 gap-5 md:gap-6'>
          {articles.map((article, i) => (
            <motion.a
              key={i}
              href={article.url}
              target='_blank'
              rel='noopener noreferrer'
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className=' group flex flex-col min-h-[320px] md:min-h-[360px] bg-cream border border-ink/15 rounded-2xl p-7 md:p-8 transition-all duration-300 hover:border-mint-deep hover:bg-raise hover:-translate-y-1 hover:shadow-xl'>
              <div className=' flex items-center justify-between'>
                <span className=' font-mono text-xs uppercase tracking-[0.15em] text-mint-deep'>{article.tag}</span>
                <span className=' font-mono text-xs text-ink/30'>0{i + 1}</span>
              </div>

              <div className=' mt-auto'>
                <h3 className=' font-display text-2xl md:text-[26px] leading-[1.15] text-maroon tracking-tight'>
                  {article.title}
                </h3>
                <p className=' text-sm leading-relaxed text-ink/55 mt-4'>{article.blurb}</p>
                <div className=' flex items-center gap-2 mt-6 font-mono text-xs uppercase tracking-[0.15em] text-ink/60 group-hover:text-mint-deep transition-colors'>
                  Read on Medium
                  <MdArrowOutward className=' text-base transition-transform duration-300 group-hover:rotate-45' />
                </div>
              </div>
            </motion.a>
          ))}
        </div>

        {/* all articles link */}
        <a
          href={MEDIUM_PROFILE}
          target='_blank'
          rel='noopener noreferrer'
          className=' group inline-flex items-center gap-2 mt-12 font-mono text-xs uppercase tracking-[0.18em] text-ink/60 hover:text-mint-deep transition-colors'>
          All articles on Medium
          <MdArrowOutward className=' text-base transition-transform duration-300 group-hover:rotate-45' />
        </a>
      </div>
    </section>
  )
}
